import type { Corporation } from '@/types/app'
import type {
  CorporationRequest,
  CorporationResponse,
} from '@/apis/repositories/models/superfrog.ts'

export const parseCorporationResponseToCorporation = (
  corporation: CorporationResponse
): Corporation => ({
  id: corporation.id,
  name: corporation.name,
  branches: corporation.branches,
})

export const parseCorporationToCorporationRequest = (
  corporation: Corporation
): CorporationRequest => ({
  id: corporation.id.toString(),
  name: corporation.name,
})
